import React from 'react'
import { FilterParam, FilterName } from '../FilterBar.types'
import { GenericFilterDropdown } from './GenericFilterDropdown'

interface UserStatusFilterDropdownProps {
  isNested?: boolean
}

export const UserStatusFilterDropdown: React.FC<
  UserStatusFilterDropdownProps
> = ({ isNested }) => {
  return (
    <GenericFilterDropdown
      filterParam={FilterParam.USER_STATUS}
      filterName={FilterName.USER_STATUS}
      valueKey="userStatuses"
      isNested={isNested}
    />
  )
}
